import { useTranslation } from 'react-i18next';

function EmptyFieldLabel() {
  const { t } = useTranslation();

  return <p className="odin-font-light odin-text-sm odin-text-gray-3 odin-py-1">{t('none', 'None')}</p>;
}

export default EmptyFieldLabel;
